<script>
    import Contact from '../../components/Contact.svelte';
    import Checkbox from '../../components/Checkbox.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import Select from '../../components/Select.svelte';
    import PageSection from '../../components/PageSection.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    import { anonymousId } from '../../analytics';
    import { pageNumber, model } from '../../stores';
    import { referralTypes, projectSettings } from '../../config';

    export let disabled = null;
    export let pageIndex = null;
    export let pageTitle = null;
    export let nextPage = null;
    export let previousPage = null;
    export let persistUrl = null;
    export let lastVisitedPage = null;

    let required = true;

    if (!disabled) {
        pageNumber.update(p => pageIndex);
        $model.LastPageVisited = lastVisitedPage;
        document.title = pageTitle;

        if (typeof window !== "undefined" && window.analytics && window.analytics.user) {
            $model.RegistrationSegmentId = anonymousId();
        }
    }

    const initialise = () => {
        console.log($model);
    }

    initialise();

</script>

<PageSection>
	<FormRow class="justify-content-center confirmation-hide">
		<FormColumn>
			<h4 class="text-center">{@html projectSettings.classActionName}</h4>
			<h1 class="text-center">Please provide your details</h1>
		</FormColumn>
	</FormRow>
    	
    <FormRow class="justify-content-center confirmation-show">
	    <FormColumn>
		    <h2>Your details</h2>
	    </FormColumn>
    </FormRow>

	<hr class="primary" />

	<div class="confirmation-box-shadow">
        <Contact bind:title="{$model.Contact.Title}"
                 bind:firstName="{$model.Contact.FirstName}"
                 bind:surname="{$model.Contact.Surname}"
                 bind:dateOfBirth="{$model.Contact.DateOfBirth}"
                 bind:emailAddress="{$model.Contact.EmailAddress}"
                 bind:phoneNumber="{$model.Contact.PhoneNumber}"
                 bind:address="{$model.Contact.Address}"
                 idPrefix="contact"
                 {required} {disabled}></Contact>

        <FormRow>
            <FormColumn>
                <Select 
            		label="Where did you hear about our firm?"
                    {required}
                    {disabled}
                    id="whereDidYouHear"
                    bind:value="{$model.WhereDidYouHear}"
                    optionList="{referralTypes}"
                    textProperty="name"
                    valueProperty="name"></Select>
            </FormColumn>
        </FormRow>
    </div>

    {#if (!disabled)}
		<FormRow class="confirmation-hide">
			<FormColumn class="last">
                <NavigationButtons {persistUrl} {previousPage} {nextPage}></NavigationButtons>
            </FormColumn>
        </FormRow>
    {/if}

</PageSection>

<style>
</style>